import(/* webpackMode: "eager" */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/app/page.tsx");
